/**
 * Created by katarinababic on 23.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import {
  WeaviateSuggestionResult,
  WeaviateSuggestionResultApi,
} from '../../Model/Suggestions/WeaviateSuggestionResult';
import { Recipe } from '../../Model/Diet/Recipe/Recipe';
import { useRootStore } from '../../Store/useRootStore';
import { useLocalized } from '../../Hooks/useLocalized';
import { useTrans } from '../../Store/System/LocalizationStore';
import { useNavigate } from 'react-router-dom';
import { StringUtils } from '../../Utils/StringUtils';
import { HomeScreenSuggestionItem } from './HomeScreenSuggestionItem';
import { getMediaMediumOrSmallest } from '../../Model/Media/Media';

function getSecondaryText(e?: Recipe) {
  if (e) {
    return `${Math.floor(e.nutrition?.nutrients.calories?.amount ?? 0)} kcal`;
  }
  return undefined;
}

export type HomeScreenRecipeSuggestionItemProps = {
  suggestion: WeaviateSuggestionResult;
  onRefresh?: () => void;
};

export const HomeScreenRecipeSuggestionItem: React.FC<HomeScreenRecipeSuggestionItemProps> = observer(
  ({ suggestion, onRefresh }) => {
    const { authentication, analytics } = useRootStore();
    const navigate = useNavigate();
    const { t } = useTrans();
    const entryName = useLocalized(suggestion.recipe?.name);
    const athlete = authentication.athlete;

    const entry = suggestion.recipe;
    const [loading, setLoading] = useState(false);

    const imageSrc = entry?.image ? getMediaMediumOrSmallest(entry.image) : require('../../Assets/Images/logo.png');
    const title = entryName ? StringUtils.shortenString(entryName, 40) : '';

    const handlePress = React.useCallback(() => {
      if (entry) {
        analytics.logEvent('coachTabRecipeSuggestion', { entryId: entry.id });
        navigate(`/nutrition/${entry.id}`);
      }
    }, [analytics, entry, navigate]);

    const refreshSuggestion = React.useCallback(() => {
      if (athlete) {
        setLoading(true);
        analytics.logEvent('refresh_suggestion', {
          ...suggestion.tags.reduce((acc, tag) => ({ ...acc, [tag]: 1 }), {}),
          category: 'nutrition',
          contentId: suggestion.contentId,
          contentType: suggestion.contentType,
        });
        WeaviateSuggestionResultApi.refresh(suggestion.category)
          .then(() => {
            onRefresh?.();
          })
          .catch((error) => {
            console.error('Failed to refresh recipe suggestion:', error);
          })
          .finally(() => setLoading(false));
      }
    }, [athlete, suggestion, analytics, onRefresh]);

    return (
      <HomeScreenSuggestionItem
        image={imageSrc as string}
        onPress={handlePress}
        title={title}
        secondaryText={getSecondaryText(entry)}
        loading={loading}
        onRefresh={refreshSuggestion}
        refreshDisabled={loading}
        onboardingSection="physicalHealth"
        suggestionType="recipe"
        typeTag={t(`coach_tab.suggestions.typeTag.recipe`, { defaultValue: 'recipe' }) ?? 'recipe'}
        locked={false}
      />
    );
  },
);
